import { InjectionToken } from '@angular/core';

export const THEME_TOKEN = new InjectionToken('Theme Config');
export const THEME_ID_TOKEN = new InjectionToken('Theme ID');

export const LANG_TOKEN = new InjectionToken('Language');

export const SEARCHES_LIST = 'searches';
